class TierPricingTable extends HTMLElement {
    constructor() {
      super();
  
      // Shadow DOM
      this.attachShadow({ mode: 'open' });
  
      // Default table styles
      const tableStyles = `
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        table-layout: fixed;
        border-collapse: collapse;
        border: 0.1rem solid rgb(var(--color-border));
        margin-top: 1rem;
        `;

  
      // Default cell styles
      const cellStyles = `
        width: 16.66%;
        height: 30px;
        box-sizing: border-box;
        border: 0.1rem solid rgb(var(--color-border));
        padding: 15px;
        `;
  
      // Create the table element
      const table = document.createElement('table');
      table.style.cssText = tableStyles;
  
      // Create the table body
      const tbody = document.createElement('tbody');
  
      // Get the JSON data from the element's attributes
      const tierPricingDiv = document.getElementById('tier-pricing');
      const tierPricingJson = tierPricingDiv.innerText;
      const jsonData = JSON.parse(tierPricingJson);
  
      // Create the heading row
      const headingRow = document.createElement('tr');
      const headingCell = document.createElement('td');
      headingCell.style.cssText = cellStyles + 'font-weight: bold;';;
      headingCell.textContent = 'Quantity';
      headingRow.appendChild(headingCell);
  
      jsonData.tiers.forEach(tier => {
        const quantityCell = document.createElement('td');
        quantityCell.style.cssText = cellStyles
        quantityCell.textContent = tier.quantity;
        headingRow.appendChild(quantityCell);
      });
  
      // Append the heading row to the table body
      tbody.appendChild(headingRow);
  
      // Create the price row
      const priceRow = document.createElement('tr');
      const priceCell = document.createElement('td');
      priceCell.style.cssText = cellStyles + 'font-weight: bold;';;
      priceCell.textContent = 'Price';
      priceRow.appendChild(priceCell);
  
      jsonData.tiers.forEach(tier => {
        const priceCell = document.createElement('td');
        priceCell.style.cssText = cellStyles;
        priceCell.textContent = `$${tier.price.toFixed(2)}`;
        priceRow.appendChild(priceCell);
      });

      if(jsonData.extras){
        jsonData.extras.forEach(extra => {
          const priceCell = document.createElement('td');
          priceCell.style.cssText = cellStyles;
          priceCell.textContent = `${extra.standard}`;
          priceRow.appendChild(priceCell);
        })
      }
  
      // Append the price row to the table body
      tbody.appendChild(priceRow);
  
      // Append the table body to the table
      table.appendChild(tbody);
  
      // Append the table to the shadow DOM
      this.shadowRoot.appendChild(table);
    }
  }
  
  // Define the custom element
  customElements.define('tier-pricing-table', TierPricingTable);
  